module.exports = __webpack_public_path__ + "media/img/millennium-a514cfb7d24f90157fec17f97472ef0d.png";